import { FC } from 'react';
import kebabCase from 'lodash/kebabCase';
import { Stack } from '@belong/ui-components';
import { removeTrailingSlash } from '@belong/url-utils';
import { IDropdownLinkGroup } from '../../GlobalHeaderDesktop/HeaderDropdown/DropdownLinkGroup';
import { GLOBAL_HEADER_TEST_ID } from '../../testids';
import { ARIA_CURRENT } from '../../variables';
import { GHMobileLink } from '../GHMobileLink';
import * as styles from './styles';

export const MobileLinkGroup: FC<IDropdownLinkGroup> = ({ navLinkGroup, currentUrl, onLinkClick }) => {
  return (
    <Stack space="xxsmall">
      <styles.LinkGroupHeading headingColor={navLinkGroup.labelColour}>{navLinkGroup.label}</styles.LinkGroupHeading>
      <styles.LinkGroup>
        {navLinkGroup.navLinks.map(navLink => {
          return (
            <GHMobileLink
              aria-current={currentUrl === removeTrailingSlash(navLink.href) ? ARIA_CURRENT : undefined}
              href={navLink.href}
              iconName={navLink.navLinkIcon}
              label={navLink.label}
              onClick={onLinkClick}
              secondLevelLink
              iconRight={false}
              data-testid={`${GLOBAL_HEADER_TEST_ID.OFFCANVASLINK_PREFIX}${kebabCase(navLink.label).toLowerCase()}`}
              key={kebabCase(navLink.label).toLowerCase()}
            />
          );
        })}
      </styles.LinkGroup>
    </Stack>
  );
};

MobileLinkGroup.displayName = 'MobileLinkGroup';
